// Lib
import * as _ from 'lodash';
import { put, debounce, select } from "redux-saga/effects";
// Constants
import * as ACTIONS from "./constants";
import host from '@utils/host';
import axios, { AxiosResponse } from 'axios';
import actions from '@state/actions';
import selectors from '@state/selectors';
import { serverError } from '@state/auth/actions';
// Types
import * as actionsInterfaces from './types';

function* getDealers(action: actionsInterfaces.ActionGetDealerAPI) {
    let token: string;
    try {
        token = process.env.REACT_APP_DS_LISMA_TOKEN??'';        
        const { page, limit, query, group, id } = action
        let queryStringParameter = `?page=${page}&size=${limit}`
        if (query) 
            queryStringParameter += `&query=${query}`        
        if (group)
            queryStringParameter += `&group=${encodeURIComponent(group)}`
        if (id)
            queryStringParameter += `&dealer=${id}`
        
        let callUrl = `${process.env.REACT_APP_DS_LISMA_API}/external/dealers${queryStringParameter}`         
        const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})        
        if (response.status >= 200 && response.status <= 300) {            
            yield put(actions.dealers.getDealerAPISuccess(response.data, page));
        }
    } catch (err) {
        yield put(actions.dealers.getDealerAPIError(err));
    }
}

function* getDealerById(action: actionsInterfaces.ActionGetDealerById) {
    let token: string;
    try {
        token = process.env.REACT_APP_DS_LISMA_TOKEN??'';                
        const { dealerId } = action
        let queryStringParameter = `?dealer=${dealerId}`
        let callUrl = `${process.env.REACT_APP_DS_LISMA_API}/external/dealers${queryStringParameter}` 
        const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
        if (response.status >= 200 && response.status <= 300) {            
            yield put(actions.dealers.getDealerByIdAPISuccess(response.data));
        }
    } catch (err) {
        yield put(actions.dealers.getDealerByIdAPIError(err));
    }
}

function* getDealerCollections(action: actionsInterfaces.IGetCollectionsAction) {
    let token: string;
    try {
        const data = { "access_token": action.collectionsRequest.access_token };
        token = yield select(selectors.auth.getAuthToken);
        const response: AxiosResponse<any> = yield axios.post(
            `${host}external/${action.collectionsRequest.dealerId}/collections`,
            data,
            { headers: { Authorization: token } },
        );
        if (response.status >= 200 && response.status <= 300) {
            yield put(actions.dealers.setDealerCollections(response.data));
            if (action.callback) { action.callback(response); }
        } else if (response.status === 400 || response.status === 401 || response.status === 403) {
            if (action.callback) { action.callback(undefined, response); }
        } else {
            yield put(serverError(response.data));
            if (action.callback) { action.callback(undefined, response); }
        }
    } catch (e) {
        yield put(serverError(e));
        if (action.callback) { action.callback(undefined, e); }
    }
}

function* getDealerAssets(action: actionsInterfaces.IGetAssetsAction) {
    let token: string;
    try {
        const data = { "access_token": action.assetsRequest.access_token };
        token = yield select(selectors.auth.getAuthToken);
        const response: AxiosResponse<any> = yield axios.post(
            `${host}external/${action.assetsRequest.dealerId}/assets/${action.assetsRequest.collection}/${action.assetsRequest.prefix}`,
            data,
            { headers: { Authorization: token } },
        );
        if (response.status >= 200 && response.status <= 300) {
            yield put(actions.dealers.setDealerAssets(response.data));
            if (action.callback) { action.callback(response); }
        } else if (response.status === 400 || response.status === 401 || response.status === 403) {
            if (action.callback) { action.callback(undefined, response); }
        } else {
            yield put(serverError(response.data));
            if (action.callback) { action.callback(undefined, response); }
        }
    } catch (e) {
        yield put(serverError(e));
        if (action.callback) { action.callback(undefined, e); }
    }
}

function* getDealerAssetsNames(action: actionsInterfaces.IGetAssetsNamesAction) {
    let token: string;
    try {
        const data = { "access_token": action.assetsNamesRequest.access_token };
        token = yield select(selectors.auth.getAuthToken);
        const response: AxiosResponse<any> = yield axios.post(
            `${host}external/${action.assetsNamesRequest.dealerId}/assetsnames/${action.assetsNamesRequest.collection}/${action.assetsNamesRequest.prefix}?names=${action.assetsNamesRequest.names.join()}`,
            data,
            { headers: { Authorization: token } },
        );
        if (response.status >= 200 && response.status <= 300) {
            yield put(actions.dealers.setDealerAssetsNames(response.data));
            if (action.callback) { action.callback(response); }
        } else if (response.status === 400 || response.status === 401 || response.status === 403) {
            if (action.callback) { action.callback(undefined, response); }
        } else {
            yield put(serverError(response.data));
            if (action.callback) { action.callback(undefined, response); }
        }
    } catch (e) {
        yield put(serverError(e));
        if (action.callback) { action.callback(undefined, e); }
    }
}

function* getExtDealerById(action: actionsInterfaces.IActionGetExtDealerById) {
    let token: string;
    try {
        token = process.env.REACT_APP_DS_LISMA_TOKEN??'';                
        const { dealerId } = action
        let queryStringParameter = `?dealer=${dealerId}`
        //
        let callUrl = `${process.env.REACT_APP_DS_LISMA_API}/external/dealers${queryStringParameter}` 
        const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
        if (response.status >= 200 && response.status <= 300) {            
            yield put(actions.dealers.getDealerByIdAPISuccess(response.data));
            if (action.callback) { action.callback(response); }
        } else if (response.status === 400 || response.status === 401 || response.status === 403) {
            if (action.callback) { action.callback(undefined, response); }
        } else {
            yield put(serverError(response.data));
            if (action.callback) { action.callback(undefined, response); }
        }

    } catch (err) {
        yield put(serverError(err));
        if (action.callback) { action.callback(undefined, err); }
    }
}


export default function* dealerSagas() {
    yield debounce(300, ACTIONS.GET_DEALER_API_REQUEST, getDealers);
    yield debounce(300, ACTIONS.GET_DEALER_BY_ID_API_REQUEST, getDealerById);
    yield debounce(300, ACTIONS.GET_DEALER_COLLECTIONS, getDealerCollections);
    yield debounce(300, ACTIONS.GET_DEALER_ASSETS, getDealerAssets);
    yield debounce(300, ACTIONS.GET_DEALER_ASSETS_NAMES, getDealerAssetsNames);
    yield debounce(300, ACTIONS.GET_EXTDEALER_BY_ID_API_REQUEST, getExtDealerById);
}
